setTimeout(function() {
    // Select the button with the class '.btn'
    let button = document.querySelector('.section-newsletter .btn');

    // Change the inner text to 'ACHETER MAINTENANT'
    if (button) {
        button.innerText = 'ACHETER MAINTENANT';
    }

    let qty = document.querySelector('.product__block__quantity');

if (qty) {
    const additionalHtml = `
     <span>Quantity</span>
    `;

    // Append the new HTML content beside the existing content
    qty.insertAdjacentHTML('beforeend', additionalHtml);
}

  
let contact_details = document.querySelector('#shopify-section-template--18617488343299__contact .wrapper--narrow.section-padding');

if (contact_details) {
    const additionalHtml = `
        <div class='contact-details'>
            <h3>Détails Du Contact</h3>
            <a href="mailto:jennifer@jeanxpert.ca" class='detail'>
                <img src='https://mechedunord.myshopify.com/cdn/shop/files/ic_baseline-email.png' alt=''> jennifer@jeanxpert.ca
            </a>
            <a href="tel:418294-5012" class='detail'>
                <img src='https://mechedunord.myshopify.com/cdn/shop/files/ic_baseline-phone.png' alt=''> 418 294-5012 
            </a>
            <div class='detail'>
                <img src='https://mechedunord.myshopify.com/cdn/shop/files/mdi_address-marker.png' alt=''> 869 rue de Puyjalon, Porte B, Baie-Comeau (Qc) G5C 1N3
            </div>
        </div>
    `;

    // Append the new HTML content beside the existing content
    contact_details.insertAdjacentHTML('beforeend', additionalHtml);
}
// add sections in product page

  var div = document.querySelector('#shopify-section-template--18617488638211__section_double_MYKM94 .text__standard.text-left');
  var section = document.querySelector('#shopify-section-template--18617488638211__section_double_MYKM94');
console.log(section)
  if (div && div.innerHTML.trim() === "" && section) {
    section.style.display = "none";
  }

  var div2 = document.querySelector('#shopify-section-template--18617488638211__section_double_zKnKJQ .text__standard.text-left');
  var section2 = document.querySelector('#shopify-section-template--18617488638211__section_double_zKnKJQ');
console.log(section2)
  if (div2 && div2.innerHTML.trim() === "" && section2) {
    section2.style.display = "none";
  }


}, 2000);

